export default __webpack_public_path__ + "static/media/180febcd-caf1-4ffc-984b-bcc63860ce0b.b21939c7.woff2";